/**
 * Che cosa significano i giudizi di accessibilita', e che cosa fare per
 * ciascuno.
 *
 * Esiste perche' la spiegazione stava in un attributo `title` dei filtri: si
 * leggeva solo passando con il mouse su un pulsante, quindi non da tastiera,
 * non da un tablet e non con uno screen reader — e chi non sapeva di doverla
 * cercare non la trovava affatto. Qui e' testo nella pagina.
 *
 * Sta dentro un `<details>`, chiusa: in «Documenti e cartelle» e in
 * «Accessibilita' dei documenti» una legenda aperta spingeva il lavoro fuori
 * dallo schermo, e chi la conosce gia' non deve rileggerla a ogni visita.
 * `<details>` e' nativo: si apre da tastiera e lo screen reader ne annuncia lo
 * stato senza codice nostro.
 *
 * Il testo viene tutto da `lib/accessibilita`: questo componente impagina, non
 * scrive. Una frase scritta qui sarebbe un secondo vocabolario, che e'
 * esattamente il difetto da cui la legenda nasce.
 */

import type { StatoAccessibilita } from "../api/types";
import {
  COME_NASCE_IL_GIUDIZIO,
  COSA_FARE,
  DESCRIZIONE_ACCESSIBILITA,
  STATI_IN_LEGENDA,
} from "../lib/accessibilita";
import { ChipAccessibilita } from "./primitive";

function Voci({ stati }: { stati: readonly StatoAccessibilita[] }) {
  return (
    <dl className="legenda">
      {stati.map((stato) => (
        <div key={stato} className="legenda__voce">
          <dt>
            <ChipAccessibilita stato={stato} />
          </dt>
          <dd>
            {DESCRIZIONE_ACCESSIBILITA[stato]}
            {COSA_FARE[stato] ? (
              <>
                {" "}
                <strong>Intervento:</strong> {COSA_FARE[stato]}
              </>
            ) : null}
          </dd>
        </div>
      ))}
    </dl>
  );
}

export function LegendaAccessibilita() {
  return (
    <details className="legenda-compatta">
      <summary>Legenda dei giudizi di accessibilita'</summary>
      <p className="campo__aiuto">{COME_NASCE_IL_GIUDIZIO}</p>
      <Voci stati={STATI_IN_LEGENDA} />
    </details>
  );
}
